/*
 * Created by jmeo at 2021-06-02
 * FileName: index.tsx
 * 协议相关路由
 */

import {Route, Switch, useRouteMatch} from "react-router-dom";

import Authorize from "@src/pages/agreement/pages/Authorize";
import PlatformAgreement from "@src/pages/agreement/pages/PlatformAgreement";

import "@assets/style/agreement.scss"

export default function () {
    const {path} = useRouteMatch()
    return <Switch>
        <Route path={`${path}/auth`} component={Authorize}/>
        <Route path={`${path}/pa`} component={PlatformAgreement}/>
    </Switch>
}